import React from "react";
import { NavLink } from "react-router-dom";
import { useUser } from "src/shared/context/UserContext";
import { useUserTheme } from "src/shared/hooks/useUserTheme";

interface TabItem {
  path: string;
  label: string;
}

const ReportsMenuTab: React.FC = () => {
  const { user } = useUser();
  const { bgClass, fontClass} = useUserTheme();

  // 🔹 Do not render anything if not Restaurant
  if (user?.businessType !== "Restaurant") {
    return null;
  }

  const tabs: TabItem[] = [
    { path: "/v1/sales-summary", label: "Sales Summary" },
    { path: "/v1/sales-report", label: "Sales Report" },
  ];

  return (
    <div className="w-full sm:px-4 lg:px-6 overflow-hidden p-1.5">
       <div className={`flex flex-col border-gray-200 p-1.5 w-fit shadow-inner rounded-lg overflow-auto bg-white`}>
        <nav className="flex gap-2" aria-label="Tabs">
          {tabs.map((tab: TabItem) => (
            <NavLink
              key={tab.path}
              to={tab.path}
              className={({ isActive }) =>
                `px-4 py-2 text-sm sm:text-base font-medium rounded-lg transition-all duration-150 ${fontClass} ${
                  isActive ? `${bgClass} text-white` : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default ReportsMenuTab;
